






















import { defineComponent } from '@vue/composition-api';
import { SelfBuildingSquareSpinner } from 'epic-spinners';

export default defineComponent({
    name: 'IncidentCard',
    props: {
        tooltip: { type: String, required: true },
        loading: { type: Boolean, required: false, default: false },
        bgColour: { type: String, required: false },
    },
    components: { SelfBuildingSquareSpinner },
});
